import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL; // Change to your backend URL

export const fetchSteps = () => axios.get(`${API_URL}/steps`);
export const updateStep = (id, data) => axios.put(`${API_URL}/steps/${id}`, data);
export const addStep = (data) => axios.post(`${API_URL}/steps`, data);
export const deleteStep = (id) => axios.delete(`${API_URL}/steps/${id}`);